import React from 'react';

import Box from '../../Box';
import useImageWithFallback from '../hooks/useImageWithFallback';
import { ImageWithFallbackProps } from '../types';
import Image from '..';

const ImageWithFallback = React.forwardRef<HTMLDivElement, ImageWithFallbackProps>((props, ref) => {
  const { classes, fallback, style, ...imageProps } = props;

  const { hasImgNotFailing, onError, onLoad } = useImageWithFallback(imageProps.src);

  if (hasImgNotFailing) {
    return (
      <Box ref={ref} className={classes?.root} style={style}>
        <Image className={classes?.image} onError={onError} onLoad={onLoad} {...imageProps} />
      </Box>
    );
  }

  return (
    <Box ref={ref} className={classes?.root} style={style}>
      {fallback}
    </Box>
  );
});

export default React.memo(ImageWithFallback);
